import { SystemMessageService } from '../model/system-message.service';
import { CrudDataSource, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { SystemMessage } from 'assets-model';
import { Observable } from 'rxjs';


export class SystemMessageDataSource extends CrudDataSource<SystemMessage> {

  constructor(private service: SystemMessageService) {
    super();
  }

  protected callLoaderService(serviceArguments: any, pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<SystemMessage>> {
    return this.service.findByFullFilters(serviceArguments, pageSpec);
  }

}


